<div id="sector-pages-main">
    <app-section-banner [bannerContent]="banner"></app-section-banner>
    <div id="sectors-page-general-container">
        @for (section of sector.sections; track $index) {
        <div class="page-section-container">
            <div class="page-section-container-top">
                <h2>{{section.title}}</h2>
                <p>{{section.description}}</p>
            </div>
            <h3>Aplicaciones</h3>
            <div class="page-section-card-container">
                @for (application of section.applications; track $index) {
                <app-page-section-card [img]="application.cardimg" [title]="application.cardtitle"
                    [description]="application.carddescription" [link]="'sectors/' + slug + '/' + application.link"></app-page-section-card>
                }
            </div>

        </div>
        }
    </div>

</div>